import { avatarColors } from "contains/contants";
import React, { FC } from "react";
import avatar1 from "images/avatars/Image-1icon.svg";
import useFetch from "hooks/useFetch";
import { useEffect, useState } from "react";
import config from "config.json";

export interface AvatarProps {
  containerClassName?: string;
  sizeClass?: string;
  radius?: string;
  imgUrl?: string;
  userName?: string;
  hasChecked?: boolean;
  hasCheckedClass?: string;
}

export interface AvatarSvgProps {
  color?: string
}
const AvatarSvg: FC<AvatarSvgProps> = ({
  color = "#0000000"
}) =>{
  return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="3rem" height="3rem" viewBox="0 0 360.000000 360.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,360.000000) scale(0.100000,-0.100000)"
    fill={color} stroke="none">
    <path d="M1630 3200 c-616 -86 -1082 -518 -1212 -1123 -31 -146 -31 -408 0
    -554 121 -566 539 -984 1105 -1105 146 -31 408 -31 554 0 283 61 519 188 718
    387 199 199 326 434 387 718 31 145 31 407 0 554 -121 567 -544 989 -1105
    1104 -116 23 -345 33 -447 19z m371 -186 c491 -83 889 -458 1000 -944 29 -128
    36 -332 15 -461 -44 -264 -166 -500 -356 -687 -40 -40 -75 -71 -76 -69 -2 1
    -19 104 -39 227 -19 124 -40 237 -46 251 -15 38 -67 85 -119 108 -111 48 -384
    91 -580 91 -196 0 -469 -43 -580 -91 -52 -23 -104 -70 -119 -108 -6 -14 -27
    -127 -46 -251 -20 -123 -38 -226 -39 -227 -7 -7 -159 153 -205 214 -111 148
    -195 350 -227 542 -21 129 -14 333 15 461 110 484 505 858 996 944 109 19 292
    19 406 0z"/>
    <path d="M1668 2664 c-95 -22 -177 -70 -254 -148 -85 -85 -128 -167 -151 -285
    -54 -274 122 -554 393 -626 76 -20 212 -20 288 0 196 52 348 216 391 420 18
    88 18 132 0 220 -43 204 -207 373 -407 420 -77 18 -184 18 -260 -1z"/>
    </g>
    </svg>

  )
}

const getAvatarColor = (semaphore: number) => {
  switch(semaphore){
    case 0: return "red"
    case 1: return "#e6db0b"
    case 2: return "blue"
    case 3: return "red"
    default: return "black"
  }
}

const Avatar: FC<AvatarProps> = ({
  containerClassName = "",
  sizeClass = "h-10 w-10 text-sm",
  radius = "rounded-full",
  imgUrl = avatar1,
  userName,
}) => {
  const url = imgUrl || "";
  const name = userName || "John Doe";
  const { data, error, isLoading, fetchData } = useFetch(
    'GET',
    `${config.backend_url}/authe/token`,
    {},
    { 'SetiaAuthorization': `${sessionStorage.getItem("user_token")}` }
  );

  const [user, setUser] = useState("Mi Cuenta")
  const [semaphore, setSemaphore] = useState(2)

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    if (data) {
      const response = data as any
      let fullname = response.firstname + ' ' + response.lastname
      sessionStorage.setItem("semaphore", response.semaphore_status);
      setUser(fullname)
      setSemaphore(response.semaphore_status)

    }
  }, [data])
return (
  <div
    className={`relative inline-flex items-center justify-center intext-neutral-100 uppercase font-semibold ${radius} ${sizeClass} ${containerClassName}`}
    style={{ marginRight: '65px', border: 'none' }}
  >
    <div className="flex items-center" style={{ border: 'none' }}>
      <p className="text-black mr-2" style={{ border: 'none',color: getAvatarColor(semaphore) }}>{user}</p>
      {url && (
        // <img
        //   className={`w-12 h-12 object-cover ${radius}`}
        //   src={url}
        //   alt={name}
        //   style={{ border: 'none' }}
        // />
        <div>
          <AvatarSvg color={getAvatarColor(semaphore)}/>
        </div>
          
      )}
    </div>
  </div>
);
};

export default Avatar;
